import React, { Component } from 'react';
import CN from 'classnames';
import * as styles from './styles.module.css';

export const hullTypes = [
  {
    name: 'Vanguard',
    aliases: ['DD', 'CL', 'CA', 'CB', 'AE'],
  },
  {
    name: 'Main',
    aliases: ['BB', 'CV', 'BM', 'AR'],
  },
  {
    name: 'DD',
    aliases: ['DD'],
  },
  {
    name: 'CL',
    aliases: ['CL'],
  },
  {
    name: 'CA',
    aliases: ['CA', 'CB'],
  },
  {
    name: 'BB',
    aliases: ['BB', 'BC', 'BM'],
  },
  {
    name: 'CV',
    aliases: ['CV', 'CVL'],
  },
  {
    name: 'SS',
    aliases: ['SS', 'SSV'],
  },
  {
    name: 'Other',
    aliases: ['BBV', 'AR', 'AE'],
  },
];

const Rarities = {
  'All Rarities': 0,
  Common: 1,
  Rare: 2,
  Elite: 3,
  'Super Rare': 4,
  'Ultra Rare': 5,
  Priority: 6,
  Decisive: 7,
};

export default class Filter extends Component {
  renderRarityFilterItem = (rarity) => (
    <span
      key={rarity}
      className={CN(styles.TypeFilterItem, {
        [styles.TypeFilterItemActive]:
          this.props.rarityFilter === Rarities[rarity],
      })}
      onClick={() => this.props.setRarityFilter(Rarities[rarity])}
    >
      {rarity}
    </span>
  );

  renderHullTypeFilterItem = (type) => (
    <span
      key={type}
      className={CN(styles.TypeFilterItem, {
        [styles.TypeFilterItemActive]: this.props.hullTypeFilter === type,
      })}
      onClick={() => this.props.setHullTypeFilter(type)}
      title={hullTypes.find((x) => x.name === type)?.aliases.join(', ')}
    >
      {type}
    </span>
  );

  rarities = [
    'All Rarities',
    'Common',
    'Rare',
    'Elite',
    'Super Rare',
    'Priority',
    'Decisive',
  ];

  types = [
    'All Types',
    // Vanguard
    'DD',
    'CL',
    'CA',
    'CB',
    'AE',

    // Main
    'BB',
    'CV',
    'BM',
    'AR',

    'BBV',
    'AE',

    // CA

    'CVL',
    'BC',
    'SS',
    'SSV',
  ];

  render() {
    const typesNew = hullTypes.map((x) => x.name);

    return (
      <div className={styles.FilterWrapper}>
        <div className={styles.TypeFilterWrapper}>
          {this.rarities.map((rarity) => this.renderRarityFilterItem(rarity))}
        </div>

        <div className={styles.TypeFilterWrapper}>
          <span
            className={CN(styles.TypeFilterItem, {
              [styles.TypeFilterItemActive]: this.props.hullTypeFilter === null,
            })}
            onClick={() => this.props.setHullTypeFilter(null)}
          >
            All Types
          </span>

          {typesNew.map((type) => this.renderHullTypeFilterItem(type))}
        </div>
      </div>
    );
  }
}
